<template>
  <div>
    <klickart-analytics-header></klickart-analytics-header>
    <metrics></metrics>
  </div>
</template>

<script>
import KlickartAnalyticsHeader from './screens/Layout/components/KlickartAnalyticsHeader';
import Metrics from './screens/Metrics/components/Main';

export default {
  components: {
    KlickartAnalyticsHeader,
    Metrics,
  },
};
</script>



// WEBPACK FOOTER //
// src/Show.vue